import { render } from "./Rouwdrukwerk.vue?vue&type=template&id=0f2a0177&scoped=true"
import script from "./Rouwdrukwerk.vue?vue&type=script&lang=js"
export * from "./Rouwdrukwerk.vue?vue&type=script&lang=js"

import "./Rouwdrukwerk.vue?vue&type=style&index=0&id=0f2a0177&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2a0177"]])

export default __exports__